<template>

    <div class="main-cn">
        <div class="main-hd">
            <h4>
                用户详情

                <el-button style="float: right; padding: 3px 0;color: #F56C6C" type="text">
                    <router-link :to="{ name: 'Dashboard',params: {}}">返回工作台</router-link>
                </el-button>
            </h4>

        </div>
        <div class="main-bd mg20">
            <el-card class="box-card">
                <div slot="header" class="clearfix">
          <span>
            <b>用户详情</b>
          </span>
                    <el-button style="float: right; padding: 3px 0" type="text" @click="handleEdit"
                               v-if="Acs('/users/update')">编 辑
                    </el-button>
                </div>
                <div v-if="user" class="text item" v-watermask>
                    <el-row>
                        <el-col :span="8">
                            <b>姓 名：</b> {{user.name}}
                        </el-col>
                        <el-col :span="8">
                            <b>手 机：</b> {{user.mobile}}
                        </el-col>
                        <el-col :span="8">
                            <b>邮 箱：</b> {{user.email}}
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8">
                            <b>昵 称：</b> {{user.nickname}}
                        </el-col>
                        <el-col :span="8">
                            <b>所属部门：</b> {{user.branch_name}}
                        </el-col>
                        <el-col :span="8">
                            <b>所属职位：</b> {{user.role_name}}
                        </el-col>
                    </el-row>
                    <p>
                        <b>QQ： {{user.qq}}</b>
                    </p>
                    <p>
                        <b>状 态： {{user.state_memo}}</b>
                    </p>
                    <p>
                        <b>创建IP： {{user.created_ip}}</b>
                    </p>
                    <p>
                        <b>创建时间： {{user.created_at}}</b>
                    </p>
                    <p v-if="user.qr_code">
                        <b>微信二维码：</b><br/>
                        <img width="200" height="200" :src="user.qr_code" class="avatar">
                    </p>
                    <div v-if="user.is_business">
                        <p>
                            <b>最大绑定客户上限： {{user.max_customer_limit}} </b>
                            &nbsp;&nbsp;&nbsp;
                            <el-tooltip placement="right">
                                <div slot="content">
                                    满足下面条件其中一个的都算库容：<br/><br/>
                                    1. 客户没有正式订单;<br/><br/>
                                    2. 客户有正式订单，但所有合作产品都已到期;
                                </div>
                                <i class="el-icon-info"></i>
                            </el-tooltip>
                        </p>
                        <p>
                            <b>最大绑定A类客户上限： {{user.max_vip_limit}}</b>
                        </p>
                    </div>
                </div>
            </el-card>

            <el-card class="box-card">
                <div slot="header" class="clearfix">
              <span>
                <b>其他资料</b>
              </span>
                    <!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
                </div>
                <div class="text item">

                    <el-tabs v-model="activeTabName" @tab-click="handleClickTab">
                        <el-tab-pane label="近三个月登录日志" name="loginLogs">

                            <el-table :data="loginLogs" style="width: 100%" v-loading="logsLoading" v-watermask>
                                <el-table-column prop="user_agent" width="500" label="UA信息"></el-table-column>
                                <el-table-column prop="login_at" label="登录时间"></el-table-column>
                                <el-table-column prop="login_ip" label="登录IP"></el-table-column>
                                <el-table-column prop="status" label="状态"></el-table-column>
                            </el-table>
                            <el-row v-if="logsLinkPage">
                                <pagination :linkPage="logsLinkPage"></pagination>
                            </el-row>
                        </el-tab-pane>
                        <el-tab-pane v-if="areas.length > 0" label="销售区域" name="areas">
                            <el-table
                                    :loading="areaLoading"
                                    :data="areas"
                                    border
                                    style="width: 100%">
                                <el-table-column prop="full_name" label="所属省市" width="180"></el-table-column>
                                <el-table-column prop="address" label="已绑定业务区域">
                                    <template slot-scope="scope">
                                        <el-tag class="areaTag" v-for="area in scope.row.districts"
                                                :key="area.district_id">
                                            {{area.district_name}}
                                        </el-tag>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-tab-pane>
                    </el-tabs>

                </div>
            </el-card>
        </div>
    </div>

</template>

<script>
    import {APP} from "~/config/app"
    import UserService from "~/services/user";
    import Pagination from "~/widgets/Pagination.vue";

    export default {
        components: {
            Pagination
        },
        data() {
            return {
                user: null,
                // 登录日志列表
                loginLogs: [],
                logsLoading: true,
                // 登录日志分页信息
                logsLinkPage: null,
                // 业务员绑定销售区域
                areas: [],
                areaLoading: true,

                // 默认被激活选中的tab页名称
                activeTabName: 'loginLogs'
            };
        },
        // 监听路由参数更新执行分页请求
        beforeRouteUpdate: function (to, from, next) {
            this.$route.query['page'] = to.query['page'];
            this.$route.query['perPage'] = to.query['perPage'];
            this.getLoginLogs(to.query['id']);
        },

        created() {
            if (this.user == null) {
                this.user = UserService.getModel();
            }

            /**
             * 查看用户详情假设当前用户同时拥有有查看用户列表和用户详情的权限
             * 那么他就具备查看指定用户详情的权限
             * 否则只可以查看自己的的个人资料
             */
            let userId = this.$store.getters.userId;
            console.log(this.$store);
            console.log(this.$router.options.routes);
            if (this.Acs('/users/index') && this.Acs('/users/view')) {
                userId = this.$route.query["id"];
            }

            this.getUserInfo(userId);
            this.getLoginLogs(userId);
        },
        methods: {
            getUserInfo(userId) {
                if (parseInt(userId) < 1) {
                    return false;
                }
                
                UserService.getInfo(userId).then(res => {
                    if (res.code == 0) {
                        this.user = res.data;
                        // 只有业务人员才需要查看
                        if (this.user.is_business) {
                            this.getAreas(this.user.id);
                        }
                        return true;
                    } else {
                        return false;
                    }
                });
            },

            getLoginLogs(userId) {
                if (parseInt(userId) < 1) {
                    return;
                }
                this.logsLoading = true;
                UserService.getLoginLogs({
                    id: userId,
                    page: this.$route.query['page'],
                    perPage: this.$route.query['perPage']
                }).then(res => {
                    if (res && res.code == 0) {
                        this.loginLogs = res.data;
                        if (res._meta) {
                            this.logsLinkPage = res._meta;
                        }
                        this.logsLoading = false;
                        return true;
                    } else {
                        return false;
                    }
                });
            },

            handleEdit() {
                this.$router.push({
                    path: "/users/update",
                    query: {id: this.user.id}
                });
            },

            /**
             * 得到业务员绑定销售区域列表
             * @param userId
             * @returns {boolean}
             */
            getAreas(userId) {
                if (parseInt(userId) < 1) {
                    return false;
                }
                UserService.getAreas(userId).then(res => {
                    this.areaLoading = false;
                    if (res.code == 0) {
                        this.areas = res.data;
                        return true;
                    } else {
                        console.error(res.msg);
                        return false;
                    }
                });
            },

            /**
             * 监听处理点击 Tab 页
             */
            handleClickTab(tab, event) {
            },
            // 是否有权限访问模块
            AccessAuth(key) {
                let data = this.$router.options.routes;
                let routes = [];
                if (data.length > 0) {
                    data.forEach(item => {
                        if (!item.hidden && item.children && item.children.length > 0) {
                            item.children.forEach(child => {
                                let path = item.path + '/' + child.path;
                                if (key == item.meta.module && (APP.enableAuthPermission ? this.Acs(path) : true) && !child.hidden) {
                                    routes.push(path);
                                }
                            });
                        }
                    });
                }
                return routes.length;
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/views/user/view.vue